export default "__VITE_ASSET__BUmYy1Fx__"